import moment, { Moment } from 'moment';

export const convertDate = (date: Date | null | Moment, separator = '-'): string | null => {
	const format = `YYYY${separator}MM${separator}DD`;
	if (date) {
		return moment(date, format).format(format);
	}
	return date;
};
